import React from "react";
import {Alert, Box, FormControlLabel, Switch, TextField} from "@mui/material";
import {useTranslation} from "react-i18next";

export const availabilityLabel = availability => ({AVAILABLE: "CourierAvailable", OFFLINE: "CourierOffline",
    ON_BREAK: "CourierOnBreak", BUSY: "CourierBusy"}[availability] || availability);

export const validCapacity = value => value !== "" && Number.isInteger(Number(value))
    && Number(value) > 0 && Number(value) <= 2147483647;

export const profileValues = profile => ({maxActiveOrders: String(profile?.maxActiveOrders ?? 1), active: profile?.active ?? true});

export default function CourierProfileForm({values, setValues, profile, disabled}) {
    const {t} = useTranslation();
    const change = (field, value) => setValues(previous => ({...previous, [field]: value}));
    const blocked = profile?.activeOrderCount > 0 && profile?.active;
    return <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
        <TextField label={t("CourierMaxActiveOrders")} type="number" value={values.maxActiveOrders} required
                   disabled={disabled} error={!validCapacity(values.maxActiveOrders)}
                   helperText={!validCapacity(values.maxActiveOrders) ? t("CourierCapacityInvalid") : " "}
                   inputProps={{min: 1, max: 2147483647, step: 1}}
                   onChange={event => change("maxActiveOrders", event.target.value)}/>
        <TextField label={t("CourierAvailability")} value={t(availabilityLabel(profile?.availability || "OFFLINE"))}
                   helperText={t("CourierAvailabilityManagedByCourier")} slotProps={{input: {readOnly: true}}}/>
        <FormControlLabel label={t("Active")} control={<Switch checked={values.active} disabled={disabled || blocked}
            onChange={event => change("active", event.target.checked)}/>}/>
        {blocked && <Alert severity="info">{t("CourierDeactivationBlocked")}</Alert>}
    </Box>;
}
